import { useTranslation } from "react-i18next";

import { Schema, useSchemaNames } from "services/databases/useSchemaNames";
import { SYSTEM_SCHEMA_NAMES } from "services/databases/utils";

import ContextMenuItem from "components/ContextMenu/ContextMenuItem";
import { WithSearchVirtualized } from "components/OutlinedSelect/OutlinedSelect";

import { ROLES_WIZARD_SET_RESOURCE_OBJECTS } from "../privilegesReducer";
import { usePrivilegesState } from "../usePrivilegesContext";
import { SelectItems } from "./SelectItems";
import { ALL_SCHEMAS } from "./constant";

type Props = {
  catalogName: string;
  index: number;
  resource: string;
};

export const SchemasItems = (props: Props) => {
  const { index, catalogName, resource } = props;
  const { privilegesState, privilegesDispatch } = usePrivilegesState();
  const schemas = useSchemaNames({ database: catalogName }).filter(
    schema => !SYSTEM_SCHEMA_NAMES.includes(schema.schemaName)
  );
  const { t } = useTranslation();

  const groupState = privilegesState.schema[index];
  const { objects } = groupState;

  const selectedSchemas = objects
    .filter(object => object.catalogName === catalogName)
    .map(object => object.name);

  const filterBulkResources = (item: { name: string; catalogName: string }) => {
    if (item.catalogName !== catalogName) {
      return true;
    }
    if (item.catalogName === catalogName) {
      return item.name !== ALL_SCHEMAS;
    }
  };

  const handleResource = (schema: { schemaName: string }) => {
    const selectedObjects = selectedSchemas.includes(schema.schemaName)
      ? objects.filter(object => {
          if (object.catalogName !== catalogName) {
            return true;
          }
          return object.name !== schema.schemaName;
        })
      : [...objects, { name: schema.schemaName, catalogName }].filter(
          filterBulkResources
        );

    privilegesDispatch({
      type: ROLES_WIZARD_SET_RESOURCE_OBJECTS,
      resource,
      index,
      database: catalogName,
      objects: selectedObjects,
    });
  };

  const renderItem = (schema: Schema) => {
    return (
      <ContextMenuItem
        key={schema.schemaName}
        value={schema.schemaName}
        text={schema.schemaName}
        direction="left"
        checked={selectedSchemas.includes(schema.schemaName)}
        onClick={() => {
          handleResource(schema);
        }}
        testId={`schema-${schema.schemaName}`}
      />
    );
  };

  return (
    <WithSearchVirtualized
      items={schemas}
      renderItem={renderItem}
      searchOptions={{
        searchPlaceholder: t("roles_wizard.privileges.search_schema"),
        searchKey: "schemaName",
      }}
      testId="database-schemas-list"
    >
      <SelectItems />
    </WithSearchVirtualized>
  );
};
